import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TfDropdownFilterComponent} from "./tf-dropdown-filter/tf-dropdown-filter.component";
import {TfMultiSelectComponent} from "./tf-multi-select/tf-multi-select.component";
import {TfMultiSelectItemComponent} from "./tf-multi-select-item/tf-multi-select-item.component";
import {TfCheckboxModule} from "@app/modules/tf-checkbox";
import {TfInputFieldsModule} from "@app/modules/tf-input-fields";
import {FormsModule} from "@angular/forms";
import {VirtualScrollerModule} from "ngx-virtual-scroller";
import {TfFilterSearchService} from "./tf-filter-search.service";
import { SortByPipe } from "./tf-filter-sort.pipe";
import { TfAutofocusDirective } from "./tf-autofocus.directive";

@NgModule({
  imports: [CommonModule, TfCheckboxModule, FormsModule, TfInputFieldsModule, VirtualScrollerModule],
  declarations: [TfDropdownFilterComponent, TfMultiSelectComponent, TfMultiSelectItemComponent, SortByPipe, TfAutofocusDirective],
  exports: [TfDropdownFilterComponent, TfMultiSelectComponent],
  providers: [TfFilterSearchService]
})
export class TfFiltersModule { }
